import type {ReactElement} from 'react';
import React from 'react';
import type {UserMailingList} from '@Components/email-marketing-campaign-performance/email-marketing-campaign-performance.types';
import styles from './mailing-list-edit-icon.module.scss';
import {ClickableDiv} from '@Components/clickable-div';
import {Icon} from '@Components/icon-v2';
import {IconSize, IconType} from '@Components/icon-v2/icon.types';

export interface MailingListEditIconProps {
  mailingList: UserMailingList;
  isMailingListSelected: boolean;
  onEditMailingList: (mailingList: UserMailingList) => void;
  isMailingListDisabled: boolean;
  containerClasses?: string;
  iconClasses?: string;
}

export default function MailingListEditIcon({
  mailingList,
  isMailingListSelected,
  onEditMailingList,
  iconClasses = '',
  containerClasses = '',
  isMailingListDisabled,
}: MailingListEditIconProps): ReactElement<any> | null {
  if (mailingList.isSmart || mailingList.isSpam) {
    return null;
  }

  return (
    <ClickableDiv
      onClick={(event) => {
        event.stopPropagation();
        onEditMailingList(mailingList);
      }}
      className={`${styles.editIconContainer} ${containerClasses}`}
    >
      <Icon
        icon={'icon-pencil'}
        className={`${styles.editIcon} ${isMailingListSelected ? styles.selected : ''} ${iconClasses}`}
        type={IconType.SECONDARY}
        size={IconSize.SIZE_ICON_20}
      />
    </ClickableDiv>
  );
}
